import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";

import uniqid from "uniqid";
import AnnouncementRow from "./AnnouncementRow";
import TopLine from "../common/TopLine";

const AnnouncementList = ({ announcements, showEditPopUp }) => {
  const titles = ["置頂", "公告時間", "公告種類", "公告標題", "公告內容"];

  return (
    <div>
      <TopLine />
      <List gridCols="grid-cols-[repeat(4,min-content)_1fr]">
        {titles.map((title) => (
          <TitleCell key={uniqid()} text={title} />
        ))}
        {announcements.map((a) => (
          <AnnouncementRow
            key={uniqid()}
            announcement={a}
            showEditPopUp={showEditPopUp}
          />
        ))}
      </List>
    </div>
  );
};

export default AnnouncementList;
